export const TOGGLE_EDIT_PASSWORD_MODAL = 'TOGGLE_EDIT_PASSWORD_MODAL'

export const TOGGLE_GENERATE_PROMOCODES_MODAL = 'TOGGLE_GENERATE_PROMOCODES_MODAL'

export const TOGGLE_REGISTER_USER_MODAL = 'TOGGLE_REGISTER_USER_MODAL'
